import { Component, OnInit } from '@angular/core';
import { loadingFade, modal, alert } from '../../animacoes';
import { FormBuilder, FormGroup } from '@angular/forms';
import { FiltroMultaPipe } from '../pipes/filtro-multa.pipe';
import { ActivatedRoute, Router } from "@angular/router";

import { MultaService } from '../services/multa.service';
import { AuthService } from '../services/auth.service';
import { ExcelService } from '../services/excel.service';
import { TipoMultaService } from '../services/tipo-multa.service';
import * as Datepicker from 'js-datepicker';
import * as moment from 'moment';
import Swal from 'sweetalert2';
import { PerfilUsuarioService } from '../services/perfil-usuario.service';

@Component({
	selector: 'app-multas',
	templateUrl: './multas.component.html',
	styleUrls: ['./multas.component.css'],
	animations: [loadingFade, modal, alert]
})
export class MultasComponent implements OnInit {

	public menu_id = 154;

	public loading = false;
	public multas = [];

	// paginacao
	public page = 1;
	public limit = 10;
	public count = 0;

	// filtro
	public filtro = [];
	public dadosFiltrados = [];
	public tipo_multa_array = [];
	public formFiltro: FormGroup;
	public showFilter = true;

	//acesso
	public usuario_perfil;
	public visualizar = true;
	public editar = false;	
	

	constructor(private fb: FormBuilder,
				private multaSvc: MultaService,
				private authSvc: AuthService,
				private excelSvc: ExcelService,
				private router: Router,	
				private route: ActivatedRoute,					
				private tipoMultaSvc: TipoMultaService,
				private perfilUsuarioSvc: PerfilUsuarioService) { }

	ngOnInit() {


		//Verifica Permissões Acesso
		this.usuario_perfil = this.authSvc.getPerfil();
		this.perfilUsuarioSvc.getByVerificaPermissao(this.usuario_perfil,this.menu_id).then((data: any[]) => {
		if(data[0].editar){
			this.editar = true;
		}
		}).catch((err) => {
		console.log(err);
		});  		

		this.criaFiltro();
		this.pegaMultas();
	}

	criaFiltro() {
		this.formFiltro = this.fb.group({
			usuario$usuario_nome: '',
			profissional$profissional_nome: '',
			tipo_multa_id: null,
			multa_data_infracao___data_i: null,
			multa_data_infracao___data_f: null,
			multa_data_notificacao___data_i: null,
			multa_data_notificacao___data_f: null
		});

		let campos_data = ['multa_data_infracao___data_i',
			'multa_data_infracao___data_f'
		];
		moment.locale('pt-Br');
		for (let campo of campos_data) {
			Datepicker('#' + campo, {
				customMonths: moment.months(),
				customDays: moment.weekdaysShort(),
				overlayPlaceholder: 'Preencha o ano',
				overlayButton: 'Enviar',
				formatter: (element, date) => {
					let formatted = moment(date).format('DD/MM/YYYY');
					this.formFiltro.controls[campo].setValue(formatted);
				}
			});
		}
		this.pegaTiposMulta();

		this.route.params.subscribe( params => {

			if(params.id){
	  
			  let splitF = params.id.split("&");
	  
			  let loUsuarioNome = null;
			  let loProfissinalNome = null;
			  let loTipoMulta = null;
			  let loData_i = "";
			  let loData_f = "";
			  let loSituacao = null;
	  
			  //this.showFilter = false;
	  
			  for (var i = 0; i < splitF.length; i++) {
	  
				var loSplitValor = splitF[i].split("=");
	  
				switch(loSplitValor[0]) { 
				  case "usuario$usuario_nome": { 
	  
					if(loSplitValor[1] !== "null"){
						this.showFilter = false;
					  loUsuarioNome = loSplitValor[1];
					}
					 break; 
	  
				  } 
				  case "profissional$profissional_nome": { 
					if(loSplitValor[1] !== "null"){
						this.showFilter = false;
					  loProfissinalNome = loSplitValor[1];
					}
	  
					break; 
				  }
				  case "tipo_multa_id": { 
					if(loSplitValor[1] !== "null"){
						this.showFilter = false;
						 loTipoMulta = parseInt(loSplitValor[1]);
					}
					 break; 
				  } 
				  case "multa_data_infracao___data_i": { 
					if(loSplitValor[1] !== "null"){
						this.showFilter = false;
					  let splitDate1 = loSplitValor[1].split("-");
					  if(splitDate1){
						loData_i = splitDate1[2] + "/" + splitDate1[1] + "/" + splitDate1[0];
					  }
					}
					 break; 
				  }      
				  case "multa_data_infracao___data_f": { 
					if(loSplitValor[1] !== "null"){
						this.showFilter = false;
					  let splitDate1 = loSplitValor[1].split("-");
					  if(splitDate1){
						loData_f = splitDate1[2] + "/" + splitDate1[1] + "/" + splitDate1[0];
					  }
					}
					 break; 
				  }      
				 }
	  
			  }
			  this.preencheForm({
				usuario$usuario_nome: loUsuarioNome,
				profissional$profissional_nome: loProfissinalNome,
				tipo_multa_id: loTipoMulta,
				multa_data_infracao___data_i: loData_i,
				multa_data_infracao___data_f: loData_f,
				multa_data_notificacao___data_i: null,
				multa_data_notificacao___data_f: null											
	  
			  });
			  this.filtra();
	  
			}
	  
		  });	

		
	}

	preencheForm(dados) {
		this.formFiltro.setValue(dados);
	}

	pegaTiposMulta() {
		this.tipoMultaSvc.getTiposMulta('tipo_multa_nome').then((data: any[]) => {
			this.tipo_multa_array = data;
		}).catch((err) => {
			console.log(err);
		});
	}

	pegaMultas() {
		this.multas = [];
		this.loading = true;
		this.multaSvc.getByUsuario(this.authSvc.getUsuarioId()).then((data: any) => {
			this.multas = data;
			this.count = this.multas.length;
			this.loading = false;
		}).catch((err) => {
			console.log(err);
		});
	}

	primPagina() {
		this.page = 1;
	}

	paginaAnt() {
		this.page = Math.max(this.page - 1, 1);
	}

	proxPagina() {
		this.page = Math.min(this.page + 1, Math.ceil(this.count / this.limit));
	}

	ultPagina() {
		this.page = Math.ceil(this.count / this.limit);
	}

	filtra() {
		this.filtro = this.formFiltro.value;
		this.dadosFiltrados = new FiltroMultaPipe().transform(this.multas, this.filtro);
		this.count = this.dadosFiltrados.length;
		this.page = 1;
	}


	apagaMulta(id) {
		Swal.fire({
			type:'warning',
			title: 'Deseja realmente apagar este registro?',
			showCancelButton: true,
			showCloseButton: true,
			confirmButtonText: 'Apagar',
			cancelButtonText: 'Cancelar',
			confirmButtonColor: '#d33'
			  
		}).then((result) => {
			if(result.value == true){
				this.multaSvc.apagaMulta(id).then((data) => {
					this.pegaMultas();
					Swal.fire({
						type: 'success',
						title: 'Apagado com sucesso!'
					});
				}).catch((err) => {
					console.log(err);
					Swal.fire({
						type: 'error',
						title: 'Ops! Algo de errado aconteceu!',
						text: 'Não foi possível apagar este registro, tente novamente mais tarde.'
					});
				});
			}
		})
	}

	exportarExcel(){
		let data = [];
		if(this.dadosFiltrados.length == 0){
			this.dadosFiltrados = this.multas;
		}
		for(let index in this.dadosFiltrados){
			data[index] = {
				'Veículo': this.multas[index].veiculo.veiculo_placa,
				'Profissional': this.multas[index].profissional == null ? '' : this.multas[index].profissional.profissional_nome,
				'Tipo de Multa': this.multas[index].tipo_multa.tipo_multa_nome,
				'Natureza': this.multas[index].tipo_multa.tipo_multa_natureza,
				'Pontuação': this.multas[index].tipo_multa.tipo_multa_pontuacao,
				'Data de Infração': this.multas[index].multa_data_infracao == null ? '' : moment(this.multas[index].multa_data_infracao).format('DD/MM/YYYY'),
				'Data de Notificação': this.multas[index].multa_data_notificacao == null ? '' : moment(this.multas[index].multa_data_notificacao).format('DD/MM/YYYY'),
				'Data de Transferência': this.multas[index].multa_data_transferencia == null ? '' : moment(this.multas[index].multa_data_transferencia).format('DD/MM/YYYY'),
				'Data de Vencimento': this.multas[index].multa_data_vencimento == null ? '' : moment(this.multas[index].multa_data_vencimento).format('DD/MM/YYYY')
			};
		}
		this.excelSvc.exportAsExcelFile(data, 'Chronos Frota - Multas');
	}

	expandPanel(){
		this.showFilter = this.showFilter == true ? false: true;
	}

	VerMultas(multa_id){

		this.filtro = this.formFiltro.value;
	
		let params = '';
	
		for (let f in this.filtro) {
		  let val = this.filtro[f];
		  if (val) {
			let aux = f.split('___');
			if (aux[1] == 'data_i' || aux[1] == 'data_f')
			  val = moment(val, 'DD/MM/YYYY').format('YYYY-MM-DD');
	
			params += (params == '')? '?' : '&';
			params += f + "=" + val;
		  }
		}
	
		//Envia dados
		this.router.navigate(['home/multas/edit/' + multa_id + params] );
	  }

	  onClickLimparCampos(){
		this.formFiltro = this.fb.group({
			usuario$usuario_nome: '',
			profissional$profissional_nome: '',
			tipo_multa_id: null,
			multa_data_infracao___data_i: null,
			multa_data_infracao___data_f: null,
			multa_data_notificacao___data_i: null,
			multa_data_notificacao___data_f: null
		});
	  }
}
